import { useRef } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import { Reveal, Eyebrow } from "./Motion";

const steps = [
  { n: "01", title: "Walkthrough", text: "We visit, measure, and listen to what you want the space to do." },
  { n: "02", title: "Clear quote", text: "An itemized estimate with materials and timeline, in plain language." },
  { n: "03", title: "The build", text: "Our crew gets to work — protecting your home and cleaning up daily." },
  { n: "04", title: "Final walk", text: "We review every detail together and don't call it done until you do." },
];

export const Process = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 80%", "end 60%"] });
  const scaleX = useSpring(scrollYProgress, { stiffness: 80, damping: 20 });

  return (
    <section id="process" ref={ref} className="relative border-t border-[#E2DDD5] bg-[#EFECE6] py-24 lg:py-36 mt-12" data-testid="process-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
        <Reveal>
          <Eyebrow>How it works</Eyebrow>
          <h2 className="mt-5 max-w-3xl font-serif-d text-5xl sm:text-6xl lg:text-7xl font-medium tracking-tight leading-[0.95]">
            Four steps. <span className="italic text-[#B04E2A]">No surprises.</span>
          </h2>
        </Reveal>
        <div className="relative mt-16 lg:mt-24">
          <div className="absolute left-0 right-0 top-0 hidden h-px bg-[#D6CFC4] lg:block" />
          <motion.div style={{ scaleX }} className="absolute left-0 right-0 top-0 hidden h-[2px] origin-left bg-[#C85A32] lg:block" />
          <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
            {steps.map((s, i) => (
              <Reveal key={s.n} delay={i * 0.1}>
                <div className="relative border-l border-[#D6CFC4] pl-6 lg:border-l-0 lg:pl-0 lg:pt-10" data-testid={`process-step-${s.n}`}>
                  <span className="absolute -top-[5px] left-0 hidden h-3 w-3 rounded-full bg-[#C85A32] lg:block" />
                  <span className="font-mono-d text-sm text-[#B04E2A]">{s.n}</span>
                  <h3 className="mt-3 font-serif-d text-3xl font-semibold">{s.title}</h3>
                  <p className="mt-3 text-sm text-[#605A52] leading-relaxed max-w-xs">{s.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
